<template lang="html">
  <div class="alert alert-warning alert-dismissible fade show" role="alert">
    <slot></slot>
    <button
      v-if="close"
      type="button"
      class="close"
      data-dismiss="alert"
      aria-label="Close"
    >
      <span aria-hidden="true"><v-icon name="close"/></span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    close: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss">
.alert {
  &.danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/alert.vue